import RapprochementMainComp from "../components/RapprochementMainComp";

interface RapprochementsContainerProps {
  year: number;
  onSetYear: (year: number) => void;
}

export default ({ year, onSetYear }: RapprochementsContainerProps) => (
  <div>
    <RapprochementMainComp year={year} onSetYear={onSetYear} />
  </div>
);
